import { Chakra } from "@airhelp/react-ui-components";
import { useLanguage, useTranslations } from "contexts/LocalizationContext";
import Grid from "modules/common/components/Grid";
import getPageUrl from "utils/getPageUrl";

const { Flex, Box, Text, Button } = Chakra;

const CallToAction = () => {
  const translations = useTranslations();
  const language = useLanguage();

  return (
    <Box bgGradient="linear(to-b, greyscale.300 50%, #ffffff 0)" mb={{ base: 16, md: 24 }}>
      <Grid mb={0}>
        <Flex
          gridColumn="1 / -1"
          width="full"
          bg="primary.500"
          justify="space-between"
          alignItems="center"
          rounded="xl"
          mx="auto"
          px={8}
          py={6}
          direction={{ base: "column", md: "row" }}
        >
          <Text
            fontWeight="bold"
            fontSize="xl"
            color="white"
            mb={{ base: 4, md: 0 }}
            textAlign={{ base: "center", md: "initial" }}
          >
            {translations("how_do_i_know")}
          </Text>
          <Button
            as="a"
            href={getPageUrl(language, "webappNewClaim")}
            variant="subtle"
            color="primary.900"
            size="s"
            width={{ base: "full", md: "initial" }}
          >
            {translations("check_compensation")}
          </Button>
        </Flex>
      </Grid>
    </Box>
  );
};

export default CallToAction;
